/*Add here your flagr's flag constant values */
export interface FlagProps {
  KEY: string;
  NAME: string;
  VARIANTS: Record<string, string>;
}

export const SEEKING_ALPHA: FlagProps = {
  KEY: 'kfrofp7n8rngnrhhn',
  NAME: 'seeking-alpha-article-flag',
  VARIANTS: {
    HAS_SEEKING_ALPHA_ARTICLES: 'hasSeekingAlphaArticles',
    NO_SEEKING_ALPHA_ARTICLES: 'noSeekingAlphaArticles',
  },
};

export const STRIPE_CHECKOUT: FlagProps = {
  KEY: 'kba3aqaofbayywb8y',
  NAME: 'has-new-checkout',
  VARIANTS: {
    HAS_OLD_CHECKOUT: 'has_old_checkout',
    HAS_NEW_CHECKOUT: 'has_new_checkout',
  },
};

export const HACKATHON_THESIS: FlagProps = {
  KEY: 'kcpbzyv9a5pi53iri',
  NAME: 'hackathon-thesis',
  VARIANTS: {
    THESIS_ON: 'Thesis_ON',
  },
};

export const USERPILOT_CLASSIFICATION: FlagProps = {
  KEY: 'kamxxia8fwyiy7u9r',
  NAME: 'userpilot-classification',
  VARIANTS: {
    CONTROL: 'defaultOnboarding',
    VALUATION_EXPERIMENT: 'userpilotOnboarding',
    MONITORING_EXPERIMENT: 'userpilot-classification-monitoring',
  },
};

export const ARTICLES_WITH_COMMENTS: FlagProps = {
  KEY: 'kynd11oevrpz7mite',
  NAME: 'articles-with-comments',
  VARIANTS: {
    COMMENTS_ON: 'articlesWithCommentsOn',
    COMMENTS_OFF: 'articlesWithCommentsOff',
  },
};

export const USERPILOT_CHECKLIST: FlagProps = {
  KEY: 'khh34idrhp4zxg6yg',
  NAME: 'userpilot-checklist',
  VARIANTS: {
    CONTROL: 'show-checklist-control',
    TEST: 'show-checklist-test',
  },
};

export const PORTFOLIO_MVP: FlagProps = {
  KEY: 'krz2oi4rh7uw2bsrr',
  NAME: 'portfolio-mvp',
  VARIANTS: {
    CONTROL: 'control',
    HAS_ACCESS: 'has-access',
  },
};

export const ARTICLES_WITH_COMMENT_BADGES: FlagProps = {
  KEY: 'kwbpgarwamsgq8wo9',
  NAME: 'article-comment-badge',
  VARIANTS: {
    SHOW_TEXT: 'showGenericText',
    SHOW_WITH_COUNT: 'showWithCount',
  },
};

export const USERPILOT_CONFIRMATION: FlagProps = {
  KEY: 'kp9qakiq8o2rm8xur',
  NAME: 'userpilot-confirmation',
  VARIANTS: {
    CONTROL: 'value-confirmation-control',
    TEST: 'value-confirmation-test',
  },
};

export const DISCOVER_TILES_ADD_TO_WATCHLIST_BUTTON: FlagProps = {
  KEY: 'kpa1x77a2fs1mvu6b',
  NAME: 'DCVR-267-add-to-watchlist',
  VARIANTS: {
    BIG_BUTTON: 'big-button',
    SMALL_BUTTON: 'small-button',
  },
};
